import { RESET_TUTORIAL, SET_TUTORIAL } from 'redux/action/type'

interface ITutorialAction {
  type: string
  data?: Partial<ITutorialState>
}

interface ITutorialState {
  isRegisterEmissionDone: boolean
  isViewAnalystDone: boolean
  isDisplayedTutorialModal: boolean
  isFinishTutorial: boolean
  isShowTutorialSection: boolean
}

const initState = {
  isRegisterEmissionDone: false,
  isViewAnalystDone: false,
  isDisplayedTutorialModal: false,
  isFinishTutorial: false,
  isShowTutorialSection: true,
}

const tutorialReducer = (
  state: ITutorialState = initState,
  action: ITutorialAction,
) => {
  switch (action.type) {
    case SET_TUTORIAL:
      return { ...state, ...action.data }
    case RESET_TUTORIAL:
      return {
        ...state,
        isRegisterEmissionDone: false,
        isViewAnalystDone: false,
        isDisplayedTutorialModal: false,
        isShowTutorialSection: true,
      }
    default:
      return state
  }
}

export default tutorialReducer
